import request from '@/utils/request'

// 查询公司信息列表
export function listInfo (query) {
  return request({
    url: '/back/introduce/list',
    method: 'get',
    params: query
  })
}

// 查询公司信息详细
export function getInfo (id) {
  return request({
    url: '/back/introduce/' + id,
    method: 'get'
  })
}

// 新增公司信息
export function addInfo (data) {
  return request({
    url: '/back/introduce',
    method: 'post',
    data: data
  })
}

// 修改公司信息
export function updateInfo (data) {
  return request({
    url: '/back/introduce',
    method: 'put',
    data: data
  })
}

// 删除公司信息
export function delInfo (id) {
  return request({
    url: '/back/introduce/' + id,
    method: 'delete'
  })
}

// 导出公司信息
export function exportInfo (query) {
  return request({
    url: '/back/introduce/export',
    method: 'get',
    params: query
  })
}
